/* ============================================================
   MOONRISE — <stats-counter> custom element
   Phase 7A for sections/main-about.liquid (stats block)
   Reference: moon-rise-framer/script.js lines 333-392

   Each .about-stat-number inside the host element animates from
   `1` up to its `data-target` value over `data-duration` ms,
   eased with easeOutExpo (leaps fast, lands gently). Animation
   fires once when the host element enters the viewport.

   Respects `prefers-reduced-motion: reduce` — sets each number
   to its final value immediately, no animation.
   ============================================================ */

(function () {
  'use strict';

  if (customElements.get('stats-counter')) return;

  function easeOutExpo(t) {
    return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
  }

  class StatsCounter extends HTMLElement {
    connectedCallback() {
      this.counters = Array.from(this.querySelectorAll('.about-stat-number'));
      if (!this.counters.length) return;

      var prefersReducedMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var ioSupported = 'IntersectionObserver' in window;
      var rafSupported = 'requestAnimationFrame' in window;

      if (prefersReducedMotion || !ioSupported || !rafSupported) {
        this.counters.forEach(this._setFinal);
        return;
      }

      var self = this;
      this._io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            self._run(entry.target);
            self._io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });

      this.counters.forEach(function (el) { self._io.observe(el); });
    }

    _setFinal(el) {
      var target = parseInt(el.getAttribute('data-target'), 10) || 0;
      el.textContent = target.toLocaleString();
    }

    _run(el) {
      var target = parseInt(el.getAttribute('data-target'), 10) || 0;
      var duration = parseInt(el.getAttribute('data-duration'), 10) || 1500;
      var start = 1;
      var startTime = null;

      function step(timestamp) {
        if (startTime === null) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        var eased = easeOutExpo(progress);
        var current = Math.round(start + (target - start) * eased);
        el.textContent = current.toLocaleString();
        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          el.textContent = target.toLocaleString();
        }
      }

      window.requestAnimationFrame(step);
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
    }
  }

  customElements.define('stats-counter', StatsCounter);
})();
